import get from 'lodash/get';

export const Holiday = data => ({
  id: data.id,
  name: data.name,
  startDate: data.startDate,
  endDate: data.endDate,
  description: data.description,
  enabled: data.enabled || false,
});

export const defaultHolidays = [];

export const responseDataToHoliday = responseData => {
  return new Holiday({
    id: get(responseData, 'id'),
    name: get(responseData, 'attributes.name'),
    startDate: get(responseData, 'attributes.startDate'),
    endDate: get(responseData, 'attributes.endDate'),
    description: get(responseData, 'attributes.description'),
    enabled: get(responseData, 'attributes.enabled'),
  });
};

export const responseToHolidayList = response => {
  if (!response) {
    return defaultHolidays;
  }
  return response.data.included.map(responseDataToHoliday);
};
